
import lazyload from "@/directives/lazyload";
import Sonya from "@/assets/images/landing/img/sonya.webp";
import Jason from "@/assets/images/landing/img/jason.webp";
import William from "@/assets/images/landing/img/william.png";
import Kelly from "@/assets/images/landing/img/Kelly.png";
import SaraK from "@/assets/images/landing/img/SaraK.png";
import LogoAmerican from "@/assets/images/landing/svg/flag-american.svg";
export default {
  data() {
    return {
      stories: [
        {
          name: "William B.",
          text:
            `Apparently I am the only person over 18 that has never used Tinder. At least that is how I felt when I realized what a dupe she must have thought I was. I like sex as much as anybody else, but I have a pretty busy life. I work fulltime and I’m working on my degree at night so random hook-ups are a distraction I don’t need right now. I like settling in with someone, being able to let my guard down. And I thought she was into that too. Saturday nights were our time to hang out, I had managed things so that was not a “school night” for me. She would stay the night and we’d do something together Sunday morning before I had to get back to it. When a guy at work told me about this great chick he scored on Tinder I was blown away. He was describing the girl I had been dating for weeks. I decided to run a Tinder Blaster search and discovered she wasn’t just active; she was VERY active. Our mellow weekends together must have been her rest days. To be fair, we hadn’t said we were exclusive, I just felt dumb for having assumed. Live and learn, right?`,
          imgMain: William,
          imgSecond: Jason,
          imgThird: Sonya,
          logo: LogoAmerican,
        },
        {
          name: "Jason L.",
          text:
            `Juggling a startup and trying to maintain a social life isn't easy. I met Carrie during a networking event and was instantly drawn to her drive and passion. We hit it off, and soon our coffee meet-ups became dinner dates. A buddy mentioned he saw someone like her on Tinder recently. I thought he was joking, but curiosity got me. Used a '<strong>Tinder profile search</strong>' and bam, there she was, super active. Guess we weren't on the same page after all. A lesson in communication for me.`,
          imgMain: Jason,
          imgSecond: Sonya,
          imgThird: William,
          logo: LogoAmerican,
        },
        {
          name: "Sonya T.",
          text:
            `Being a single mom means I cherish my free time. When I met Alyssa at a parent-teacher conference, I felt we connected on a deeper level. We started seeing each other, and I was hopeful. One day, my teenage daughter, trying to be protective, hinted she saw her on Tinder. I couldn't believe it. Plugged her name into a '<strong>Tinder profile search</strong>' and the results were clear. She was still exploring. It hurt, but it's better to know sooner than later.`,
          imgMain: Sonya,
          imgSecond: William,
          imgThird: Jason,
          logo: LogoAmerican,
        },
      ],
      transitionClass: "list-next",
      pageNumber: 0,
    };
  },
  methods: {
    prevPage() {
      this.pageNumber--;
      this.transitionClass = "list-prev";
    },
    nextPage() {
      this.pageNumber++;
      this.transitionClass = "list-next";
    },
  },
  directives: {
    lazyload,
  },
};
